// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-inner-declarations */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable camelcase */

try {
	async function ekhoCheckoutSubmitOrderFunction() {
		function setButtonLoading() {
			const button = document.getElementById('ekho-maeving-checkout-button');
			const loadingButton = document.getElementById('ekho-maeving-checkout-button-loading');
			button.style.display = 'none';
			loadingButton.style.display = 'block';
			const ekhoMaevingErrorMessage = document.getElementById('ekho-maeving-error-message');
			ekhoMaevingErrorMessage.style.display = 'none';
		}
		function setNormalButton() {
			const button = document.getElementById('ekho-maeving-checkout-button');
			const loadingButton = document.getElementById('ekho-maeving-checkout-button-loading');
			button.style.display = 'flex';
			loadingButton.style.display = 'none';
		}
		function setErrorMessage(errorMessage) {
			const ekhoMaevingErrorMessage = document.getElementById('ekho-maeving-error-message');
			ekhoMaevingErrorMessage.style.display = 'block';
			ekhoMaevingErrorMessage.textContent = errorMessage;
			setTimeout(() => {
				ekhoMaevingErrorMessage.style.display = 'none';
			}, 5000);
		}
		// Add the .ekho-checkout-button-disabled class to the checkout button below
		setButtonLoading();
		const button = document.getElementById('ekho-maeving-checkout-button');
		if (!button) {
			setErrorMessage('An error occurred. Please try again or contact support.');
			setNormalButton();
			return;
		}
		// HIDE OUR BUTTON AND SHOW LOADING BUTTON
		let shopifyCartItems = [];
		let hasRM1SLaunchEdition = false;
		try {
			const response = await fetch('/cart.js');
			if (!response.ok) {
				throw new Error(`Failed to fetch Shopify cart: ${response.status}`);
			}
			const cartData = await response.json();
			shopifyCartItems = cartData.items.map((item) => {
				let metadata = {}
				if (item.product_title.indexOf('RM1S') > -1) {
					hasRM1SLaunchEdition = true;
					if ($('.rm1s-preorder-info').length > 0) {
						metadata = {
							metadata: {
								existingPayments: [
									{
										amount: $($('.rm1s-preorder-info')?.[0]).data('amount') / 100,
										type: "PREORDER",
										recipient: "OEM"
									}
								],
							}
						}
					}
				}

				// Transform options_with_values into the specs array
				const specs = item.options_with_values.map((option) => ({
					name: option.name,
					price: 0,
					option: option.value,
				}));
				return {
					productId: item.product_id?.toString(),
					variantId: item.variant_id?.toString() || '',
					basePrice: Number(item.final_price) / 100,
					specs,
					name: item.product_title,
					imgUrl: item.image,
					count: item.quantity ? Number(item.quantity) : 1,
					sku: (item.product_title.indexOf('RM1S') > -1 || item.product_id == "8135670661275") ? $('input[name="SKU"]').val() : '',
					...metadata
				};
			});
		} catch (error) {
			setErrorMessage('An error with Shopify occurred. Please reload the page and try again');
			setNormalButton();
		}
		const url = `${window.ekhoFuncHost}/checkoutCart_oncreate_v2`;
		// Hard code reg state as CA for now
		let requestBody = {
			registrationState: null,
			cancelUrl: window.location.href,
			items: shopifyCartItems,
			nativeDefaultCheckoutUrl: window.location.href,
			ecommUserId: null,
			oemKey: window.ekhoOemKey,
		};

		if (window.RM1SPrivateConfigurator) {
			if ($('.rm1s-preorder-info').length > 0) {
				requestBody = Object.assign({}, requestBody, {
					ecommOrderId: $($('.rm1s-preorder-info')?.[0])?.data('order-id')?.toString()
				});
			}
		}

		let customerPrefilledInfo = {}
		if ($('.customer-address-info').length > 0) {
			customerPrefilledInfo = {
				prefilledInfo: {
					buyerFullName: $($('.customer-address-info')?.[0])?.data('full-name') || '',
					buyerPhone: $($('.customer-address-info')?.[0])?.data('phone') || '',
					buyerEmail: $($('.customer-address-info')?.[0])?.data('email') || '',
					// selectedPaymentOption: "STANDARD_RESERVATION",
					selectedDeliveryOption: "PICK_UP",
					selectedRegistrationOption: "EKHO",
					shippingAddress: {
						addressString: $($('.customer-address-info')?.[0])?.data('default-address') || '',
						addressLineOne: $($('.customer-address-info')?.[0])?.data('default-address-1') || '',
						addressLineTwo: $($('.customer-address-info')?.[0])?.data('default-address-2') || '',
						city: $($('.customer-address-info')?.[0])?.data('default-city') || '',
						county: '',
						state: $($('.customer-address-info')?.[0])?.data('default-state') || '',
						zip: $($('.customer-address-info')?.[0])?.data('default-zip') || ''
					}
				}
			}
		}

		let customLinkConfig = {};
        console.log("private:", window.RM1SPrivateConfigurator)
		if (window.RM1SPrivateConfigurator) {
			customLinkConfig = {
				customLinkConfig: {
					linkName: "",
					checkoutPaymentOverride: {
						CHECKOUT_FULL_PAYMENT: {
							paymentTypeEnum: "CHECKOUT_FULL_PAYMENT",
							fullPaymentDiscountPerc: 0
						},
						LOAN_DOWNPAYMENT: {
							paymentTypeEnum: "LOAN_DOWNPAYMENT",
							checkoutDownPaymentPerc: 0
						}
					},
					...customerPrefilledInfo
				}
			}
		}

		requestBody = Object.assign({}, requestBody, {
			orderCreationType: window.RM1SPrivateConfigurator ? "PREORDER" : "ANTE_PREORDER",
			linkUseType: window.RM1SPrivateConfigurator ? "SINGLE_USE" : "MULTI_USE",
			...customLinkConfig
		})

		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(requestBody),
			});
			if (!response.ok) {
				throw new Error(`Server responded with status ${response.status}`);
			}
			const data = await response.json();
			const { ekhoCheckoutCartId } = data;
			if (ekhoCheckoutCartId) {
				setTimeout(() => {
					setNormalButton();
				}, 5000);
				if (window.ekhoBaseUrl) {
					window.location.href = `${window.ekhoBaseUrl}/checkout?&cartId=${ekhoCheckoutCartId}`;
				} else {
					window.location.href = `https://${window.ekhoOemKey}-checkout.ekhodealer.com/checkout?&cartId=${ekhoCheckoutCartId}`;
				}
			} else {
				// Take the buyer to the Shopify checkout page (which is /checkout)
				window.location.href = '/checkout';
			}
		} catch (error) {
			console.error('Error creating checkout session:', error.message);
			setErrorMessage(
				'An error occurred while creating your checkout session. Please reload the page and try again or contact support.',
			);
			setNormalButton();
		}
	}

	async function addItemsToCart() {
		$('#configurator-form-submit #configurator-form-submit').prop('disabled', true)
		$('#configurator-form-submit .submit-text').hide();
		$('#configurator-form-submit .submit-in-progress').show();

		var form = $("#configurator-form");
		var formData = new FormData(form?.[0]);
		var seat_colour = formData.get('Seat Colour') || "";
		var seat_type = formData.get('Seat Product') || "";
		var suspension = formData.get('K-Tech Razor Lite Suspension') || "";
		var dock = formData.get('Extra Products') || "";
		var storage = formData.get('Maeving Roll Top Pannier') || "";
		var gps_tracker = formData.get('GPS Security Tracker') || "";

		var variants_to_add = [];
		variants_to_add.push({
			'id': parseInt($('.variant-to-be-added').val()),
			'quantity': 1,
		}); // main product variant Id

		if (gps_tracker == "Yes") {
          if (!!$('.product-to-be-added[name="security"]')?.val()) {
            variants_to_add.push({
				'id': parseInt($('.product-to-be-added[name="security"]').val()),
				quantity: 1,
			}); // Tracker
          }
		}
		
		if (seat_type == 'Embossed') {
			// seat_variant_id = $('.product-to-be-added[data-product-name="Embossed Seat"]').val();
			// if (seat_colour == 'Black Seat') {
			// 	seat_variant_id = '45055530827931';
			// }
			// variants_to_add.push({
			// 	'id': parseInt(seat_variant_id),
			// 	quantity: 1,
			// });
		} else if (seat_type == 'Hand-stitched') {
			seat_variant_id = $('.extra-product-variant-to-be-added[data-product-name="Hand-Stitched Seat"]').val();
			// if (seat_colour == 'Black Seat') {
			// 	seat_variant_id = '45055530729627';
			// }
			variants_to_add.push({
				'id': parseInt(seat_variant_id),
				quantity: 1,
			});
		}

		if (suspension == 'K-Tech_Razor_Lite') {
			variants_to_add.push({
				'id': parseInt($('.product-to-be-added[name="suspension"]').val()),
				'quantity': 1,
			});
		}
      
		if (dock.includes('RM1S Dual Charging Dock')) {
			variants_to_add.push({
				'id': parseInt($('.product-to-be-added[name="charging"]').val()),
				'quantity': 1,
			});
		}

		if (storage == 'Maeving Roll-Top Pannier') {
			variants_to_add.push({
				'id': parseInt($('.product-to-be-added[name="storage"]').val()),
				quantity: 1,
			});
		}

		const clearCartResponse = await fetch('/cart/clear.js', {
			method: "POST"
		});

		if (clearCartResponse.ok) {
			await clearCartResponse.json();
			const createCartResponse = await fetch('/cart/add.js', {
				method: "POST",
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({'items': variants_to_add})
			});

			if (createCartResponse.ok) {
				test = await createCartResponse.json();
				console.log("hello", test)
				ekhoCheckoutSubmitOrderFunction({}, false);
			}
		}
	}
	async function runOnLoad() {
		try {
			if (!window.ekhoScriptLoaded) {
				const currEnv = 'production';
				window.ekhoScriptLoaded = true;
				switch (currEnv) {
					case 'development':
						window.ekhoOemKey = 'checkout-test-oem';
						window.ekhoOemId = 'checkout-test-oem-id';
						window.ekhoFuncHost =
							'https://us-central1-airdealer-67669.cloudfunctions.net';
						window.ekhoBaseUrl = 'http://localhost:3000';
						break;
					case 'staging':
						window.ekhoOemKey = 'maeving';
						window.ekhoOemId = 'QZzao3tGSmDzt94SfAWG';
						window.ekhoFuncHost = 'https://us-central1-ed-staging.cloudfunctions.net';
						window.ekhoBaseUrl = `https://${window.ekhoOemKey}-checkout.ekhodealer.com`;
						break;
					case 'production':
						window.ekhoOemKey = 'maeving';
						window.ekhoOemId = 'QZzao3tGSmDzt94SfAWG';
						window.ekhoFuncHost =
							'https://us-central1-ad-backend-prod.cloudfunctions.net';
						window.ekhoBaseUrl = `https://${window.ekhoOemKey}-checkout.ekhodealer.com`;
						break;
					default:
						window.ekhoOemKey = 'maeving';
						window.ekhoOemId = 'QZzao3tGSmDzt94SfAWG';
						window.ekhoFuncHost =
							'https://us-central1-ad-backend-prod.cloudfunctions.net';
						window.ekhoBaseUrl = `https://${window.ekhoOemKey}-checkout.ekhodealer.com`;
						break;
				}
				document.addEventListener('click', (event) => {
					// Check if the clicked element is the ekho-maeving-checkout-button or a child of it
					if (event.target.closest('#ekho-maeving-checkout-button')) {
						ekhoCheckoutSubmitOrderFunction(event);
					} else if (event.target.closest('#ekho-info-trigger')) {
						const tooltip = document.getElementById('ekho-tooltip');
						if (tooltip) {
							tooltip.style.display =
								tooltip.style?.display === 'none' ? 'block' : 'none';
						}
					}
				});

				$('#configurator-form-submit').on('click', function(event){
					event.preventDefault();
					addItemsToCart();
				})

				// Function to fetch Shopify cart and check for a specific product
				async function checkProductInCart(productId) {
					try {
						const response = await fetch('/cart.js');
						if (!response.ok) {
							throw new Error(`Failed to fetch Shopify cart: ${response.status}`);
						}
						const cartData = await response.json();

						return cartData.items.some(
							(item) => item.product_id.toString() === productId,
						);
					} catch (error) {
						console.error('Failed to check product in cart:', error);
						return false; // Assume product is not in cart if there's an error
					}
				}
				const ekhoCheckoutFinancingCopyHtml = `<h5><strong>FINANCE THE RM1 WITH <span id="ekho-info-trigger">EKHO</span></strong></h5>
				<div id="ekho-tooltip" style="display: none;">
					Maeving has partnered with <a href='https://www.ekhodealer.com' target='_blank' style="text-decoration: underline;">Ekho Dealer</a> to make online vehicle checkout quick and easy. With Ekho, you'll be able to finance, insure, and register your bike entirely online without a visit to the DMV.
				</div>
				<p><strong>For as low as $95/month</strong></p>
				<p>1. Continue to checkout</p>
				<p>2. When presented with payment options, select - <strong>FINANCING</strong></p>
				<p>3. Complete your checkout process</p>`;
				function injectEkhoCheckoutFinancingCopy() {
					const rm1ProductId = '7759622373531';
					checkProductInCart(rm1ProductId).then((isProductInCart) => {
						const cartDrawerMessage = document.querySelector('.drawer__footer');
						const ekhoFinancingCopyOld = document.getElementById('ekho-financing-copy');
						if (isProductInCart) {
							// If the product is in the cart, inject the financing copy
							// Append a div to the cart-drawer__message div with the id of ekho-financing-copy and include copy

							// Only inject if it doesn't already exist
							if (cartDrawerMessage && !ekhoFinancingCopyOld) {
								// hide cartDrawerMessage
								const ekhoFinancingCopy = document.createElement('div');
								// add a class
								ekhoFinancingCopy.classList?.add('drawer__footer');
								ekhoFinancingCopy.id = 'ekho-financing-copy';
								ekhoFinancingCopy.innerHTML = ekhoCheckoutFinancingCopyHtml;
								// Use insertAdjacentElement to place the new div after the cartDrawerMessage div
								cartDrawerMessage.insertAdjacentElement(
									'beforebegin',
									ekhoFinancingCopy,
								);
							}
						} else if (ekhoFinancingCopyOld) {
							// If the product is not in the cart, remove financing copy if it exists
							ekhoFinancingCopyOld.remove();
						}
					});
				}
				function handleEkhoEnabled() {
					const buttonContainer = document.querySelector('#ekho-maeving-checkout-button');
					if (buttonContainer) {
						buttonContainer.style.display = 'flex';
					}

					const checkoutDisclaimer = document.querySelector(
						'#ekho-maeving-checkout-disclaimer',
					);
					if (checkoutDisclaimer) {
						checkoutDisclaimer.style.display = 'block';
					}

					const oemCheckoutButton = document.querySelector('#oem-checkout-drawer-button');
					if (oemCheckoutButton) {
						oemCheckoutButton.style.display = 'none';
					}
					const oemCheckoutButton2 = document.querySelector('#oem-checkout-button');
					if (oemCheckoutButton2) {
						oemCheckoutButton2.style.display = 'none';
					}
					// Find the ekho-financing-copy div and set display to block
					const ekhoFinancingCopy = document.querySelector('#ekho-financing-copy');
					if (ekhoFinancingCopy) {
						ekhoFinancingCopy.style.display = 'block';
						// set the innerHTML to the new copy
						ekhoFinancingCopy.innerHTML = ekhoCheckoutFinancingCopyHtml;
					}
				}
				function handleEkhoDisabled() {
					const buttonContainer = document.querySelector('#ekho-maeving-checkout-button');
					if (buttonContainer) {
						buttonContainer.style.display = 'none';
					}

					const checkoutDisclaimer = document.querySelector(
						'#ekho-maeving-checkout-disclaimer',
					);
					if (checkoutDisclaimer) {
						checkoutDisclaimer.style.display = 'none';
					}
					const oemCheckoutButton = document.querySelector('#oem-checkout-drawer-button');
					if (oemCheckoutButton) {
						oemCheckoutButton.style.display = 'block';
					}
					const oemCheckoutButton2 = document.querySelector('#oem-checkout-button');
					if (oemCheckoutButton2) {
						oemCheckoutButton2.style.display = 'block';
					}
					// Find the cart-drawer__message div and set display to block
					const cartDrawerMessage = document.querySelector(
						'.cart-drawer__message.original-message',
					);
					if (cartDrawerMessage) {
						cartDrawerMessage.style.display = 'block';
					}
					// Find the ekho-financing-copy div and set display to block
					const ekhoFinancingCopy = document.querySelector('#ekho-financing-copy');
					if (ekhoFinancingCopy) {
						ekhoFinancingCopy.style.display = 'none';
					}
				}
				// TO DISABLE EKHO SET BELOW TO true
				const isEkhoDisabled = false;
				// check if ekho is disabled
				if (isEkhoDisabled) {
					// do nothing
					handleEkhoDisabled();
				} else {
					const observer = new MutationObserver(injectEkhoCheckoutFinancingCopy);
					// Start observing the body for added nodes
					observer.observe(document.body, { childList: true, subtree: true });
					handleEkhoEnabled();
				}
			}
		} catch (err) {
			console.log(err);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', runOnLoad);
	} else {
		// The DOMContentLoaded event already fired
		runOnLoad();
	}
} catch (error) {
	console.error('Error in maevingLoadStates.js:', error);
}